﻿export const LANG_BS_NAME = 'bs';

export const LANG_BS_TRANS = {
    'broj_prituzbe':'Broj pritužbe',
    'sacuvaj_lokaciju':'Sačuvaj lokaciju',
    'dodaj_dokumenat':'Dodaj dokumenat',
    'posalji_obavjestenje_o_azuriranju':'Pošalji obavještenje o ažuriranju',
    'notifikacija_poslata_korisnicima': 'Obavještenje je poslato korisnicima',
    'preuzmi_upute': 'Preuzmi upute',
    'anketar': 'Anketar',
    "surveysYear1All": "Broj završenih anketa u prethodnoj godini - lokalne",
    "surveysYear2All": "Broj završenih anketa u prethodne 2 godine - lokalne",
    "surveysYear3All": "Broj završenih anketa u prethodne 3 godine - lokalne",
    "surveysYear1Global": "Broj završenih anketa u prethodnoj godini - globalne",
    "surveysYear2Global": "Broj završenih anketa u prethodne 2 godine - globalne",
    "surveysYear3Global": "Broj završenih anketa u prethodne 3 godine - globalne",
    "mobileUsers": "Korisnici mobilnih aplikacija  - kreirani nalozi",
    'statistika_koristenja_eCitizen_aplikacije': 'Statistika korištenja eCitizen aplikacije',
    'usersSum': 'Broj korisnika - ukupno',
    'anonymous': 'Anonimni korisnici',
    'registered': 'Registrovani korisnici',
    'administrator': 'Administrator',
    'office': 'Službenik',
    'officeModerator': 'Službenik - Moderator',
    'manager': 'Menadžer',
    'orgUnit': 'Organizacija',
    'councilMember': 'Vijećnik',
    'mayor': 'Načelnik',
    'institution': 'Ustanova',
    'service': 'Servis',
    'complaintsSum': 'Broj pritužbi',
    'complaintsOpenedInTheReportingPeriod': 'Broj pritužbi - Otvorene u izvještajnom periodu',
    'complaintsResolvedInTheReportingPeriod': 'Broj pritužbi - Riješene u izvještajnom periodu',
    'complaintsOpenedAndResolvedInTheReportingPeriod': 'Broj pritužbi - Otvorene i riješene u izvještajnom periodu',
    'complaintsAverageAnswerTimeInTheReportingPeriod': 'Prosječno vrijeme odgovora (dana) na pritužbu u izvještajnom periodu',
    'complaintsAverageResolveTimeInTheReportingPeriod': 'Prosječno vrijeme (dana) za rješenje na pritužbu u izvještajnom periodu',
    'questionsTotalAnswersInTheReportingPeriod': 'Broj odgovora u izvještajnom periodu',
    'questionsAverageResponseTimeInTheReportingPeriod': 'Prosječno vrijeme odgovora (dana) na pitanje u izvještajnom periodu',
    'sessionsTotalNumberOfPointsInTheReportingPeriod': 'Ukupan broj tačaka svih sjednica u izvještajnom periodu',
    'debatesAverageDurationInTheReportingPeriod': 'Prosječno vrijeme trajanja (dana) rasprave u izvještajnom periodu',
    'administrativeProcedures': 'Ukupni broj upravnih postupaka',
    'questions': 'Broj pitanja',
    'sessions': 'Broj sjednica',
    'debates': 'Broj javnih rasprava',
    'demografska_pitanja': 'Demografska pitanja',
    'podaci_neispravni': 'Uneseni podaci nisu ispravni',
    'pitanje_zavrsavanje_ankete': 'Da li ste sigurni da želite završiti anketu',
    'potvrda_zavrsavanje_ankete': 'Potvrda završetka ankete',
    'anketa_uspjesno_zavrsena': 'Anketa je uspješno završena',
    'Pomjeri': 'Pomjeri',
    'zaustavi_anketu': 'Završi anketu',
    'min_ispitanika': 'Minimalno ispitanika',
    'br_usenika': 'Broj učesnika',
    'Odabir člana vijeća/načelnika/gradonačelnika': 'Odabir člana vijeća/načelnika/gradonačelnika',
    'adm_proc_uspjesno_obrisan': 'Administrativna procedura uspješno obrisana',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_adm_proc': 'Da li ste sigurni da želite da obrišete administrativnu proceduru',
    'Starosna_struktura_obavezna': 'Starosna struktura je obavezna',
    'Podrucje_obavezno': 'Područje je obavezno',
    'osjetljive_kategorije_obavezno': 'Osjetljiva kategorija je obavezna',
    'period_nezaposlenosti_obavezan': 'Period nezaposlenosti je obavezan',
    'status': 'Status',
    'zapoceta': 'Započeta',
    'nezapoceta': 'Nezapočeta',
    'zavrsena': 'Završena',
    "odaberite_period_nezaposlenosti": "Koliko dugo ste nezaposleni?",
    "odaberite_osjetljive_kategorije": "Pripadate li nekoj od osjetljivih kategorija?",
    "period_nezaposlenosti": "Period nezaposlenosti",
    "nastavi_kasnije": "Nastavi kasnije",
    'detalji_ucesnik': 'Detalji o učesniku',
    'starosna_struktura': 'Starosna struktura',
    'odaberite_podrucje': 'U kojoj vrsti sredine stanujete?',
    'odaberite_starost': 'Kojoj starosnoj grupi pripadate?',
    'odaberite_pol': 'Koji je vaš pol?',
    'Podrucje': 'Sredina stanovanja',
    'participant_details_instruction': 'Prije pokretanja ankete potrebno je odgovoriti na sledeća pitanja koja se odnose na učesnika ankete. Nakon popunjavanja navedenih pitanja anketa će biti započeta',
    'moje_ankete': 'Moje ankete',
    'javne_ankete': 'Javne ankete',
    'verifikacija_telefona': 'Verifikacija telefona',
    'uneseni_kod_pogresan': 'Uneseni kod nije ispravan',
    'phone_verification_instruction1': 'Za pokretanje ankete neophodno је unijeti verifikacioni kod. Ukoliko nemate kod odaberite opciju "Nemate kod?", ili kliknite',
    'phone_verification_instruction2': 'ovdje',
    'phone_verification_instruction3': ', zatim unesite Vaš broj telefona, nakon toga verifikacioni kod biće Vam dostavljen putem SMS poruke.',
    'Verifikuj': 'Verifikuj',
    'zapocni': 'Započni',
    'nemate_kod': 'Nemate kod',
    'imate_kod': 'Dobili ste kod',
    'kod_neispravan': 'Kod nije ispravan',
    'Pocetak_vazenja_od': 'Početak važenja od',
    'Pocetak_vazenja_do': 'Početak važenja do',
    'Kraj_vazenja_od': 'Kraj važenja od',
    'Kraj_vazenja_do': 'Kraj važenja do',
    'Pocetna': 'Početna',
    'Hvala_na_ucescu': 'Hvala na učešću',
    'verifikacioni_kod_nije_poslat_SMS': 'Uneseni broj je iskorišten za izabranu anketu.',
    'verifikacioni_kod_poslat_SMS': 'Verifikacioni kod je uspješno poslat SMS-om.',
    'ponovno_slanje_je_moguce_za': 'Ponovno slanje je moguće za',
    'posalji_kod': 'Pošalji kod',
    'Telefonski_broj_neispravan': 'Telefonski broj nije ispravan',
    'odgovor_nije_popunjen': "Odgovor nije popunjen",
    'anketa': 'Anketa',
    'vazi_do': 'Važi do',
    'prethodno': 'Prethodno',
    'sledece': 'Sljedeće',
    'popunjeno': 'Popunjeno',
    'pitanje_broj': 'Pitanje broj',
    'odaberite_organizacionu_jedinicu': 'Odaberite organizacijsku jedinicu',
    'organizacione_jedinice_pitanja': 'Pitanja organizacijskim jedinicama',
    'pitanja_za_organizacione_jedinice_detalji': 'Pitanja postavljena organizacijskoj jedinici',
    'pitanje_brisanje_statusa_ankete': 'Da li ste sigurni da želite izbrisati status ankete',
    'potvrda_brisanja_statusa_ankete': 'Potvrda brisanja status ankete',
    'uspjesno_obrisan_status_ankete': 'Status ankete je uspješno obrisan',
    'lista_statusa_anketa': 'Lista statusa anketa',
    'statusi_anketa': 'Statusi anketa',
    'unos_novog_statusa_anketa': 'Unos novog statusa anketa',
    'izmjena_statusa_anketa': 'Izmjena statusa anketa',
    'vrste-ucesnika-anketa': 'Vrste učesnika anketa',
    'lista-vrsta-ucesnika-anketa': 'Lista vrsta učesnika anketa',
    'izmjena_vrste_ucesnika_ankete': 'Izmjena vrste učesnika ankete',
    'unos_nove_vrste_ucesnika_ankete': 'Unos nove vrste učesnika ankete',
    'izmjena_tipa_ankete': 'Izmjena tipa ankete',
    'unos_novog_tipa_ankete': 'Unos novog tipa ankete',
    'uspjesno_obrisana_vrsta_ucesnika_ankete': 'Vrsta učesnika ankete je uspješno obrisana',
    'potvrda_brisanja_vrste_ucesnika_ankete': 'Potvrda brisanja vrste učesnika ankete',
    'pitanje_brisanje_vrste_ucesnika_ankete': 'Da li ste sigurni da želite izbrisati vrstu učesnika ankete',
    'tipovi-anketa': 'Tipovi anketa',
    'lista-tipova-anketa': 'Lista tipova anketa',
    'pitanje_brisanje_tipa_ankete': 'Da li ste sigurni da želite izbrisati tip ankete',
    'potvrda_brisanja_tipa_ankete': 'Potvrda brisanja tipa ankete',
    'uspjesno_obrisan_tip_ankete': 'Tip ankete je uspješno obrisan',
    'pitanje_brisanje_kategorije_ankete': 'Da li ste sigurni da želite izbrisati kategorija ankete',
    'potvrda_brisanja_kategorije_ankete': 'Potvrda brisanja kategorije ankete',
    'uspjesno_obrisan_kategorija_ankete': 'Kategorija ankete je uspješno obrisan',
    "kategorija_anketa": "Kategorije anketa",
    "lista_kategorija_anketa": "Lista kategorija anketa",
    "izmjena_kategorije_anketa": "Izmjena kategorija anketa",
    "unos_nove_kategorije_anketa": "Unos nove kategorije anketa",
    'pitanje_brisanje_pravnog_lijeka': 'Da li ste sigurni da želite izbrisati pravni lijek',
    'potvrda_brisanja_pravnog_lijeka': 'Potvrda brisanja pravnog lijeka',
    'uspjesno_obrisan_pravni_lijek': 'Pravni lijek je uspješno obrisan',
    "Dodaj": "Dodaj",
    "Naslov": "Naslov",
    "Naziv": "Naziv",
    "Tekst": "Tekst",
    "Opis": "Opis",
    "Kod": "Kod",
    "Redoslijed": "Redoslijed",
    "Aktivan": "Aktivan",
    "PostaviNaVrh": "Postavi na vrh",
    "Nema_podataka": "Nema podataka",
    "Da": "Da",
    "Ne": "Ne",
    "Spasi": "Spasi",
    "Odustani": "Odustani",
    "Naziv_dokumenta": "Naziv dokumenta",
    "Tip_dokumenta": "Tip dokumenta",
    "Dokument": "Dokument",
    "Dodatni_materijali_obavijesti": "Dodatni materijali/obavijesti",
    "Korisnicko_ime": "Korisničko ime",
    "Opcina_Opstina_Grad": "Općina/Opština/Grad",
    "Anonimni_korisnik": "Anonimni korisnik",
    "Registrovani_korisnik": "Registrovani korisnik",
    "Registrujte_se": "Registrujte se",
    'Lozinka': 'Lozinka',
    'Korisnicko_ime_obavezno': 'Korisničko ime je obavezno',
    'Lozinka_obavezna': 'Lozinka je obavezna',
    'Lozinka_obavezna_duzina': 'Lozinka mora biti dužine 8 karaktera',
    'Potvrdi_lozinku': 'Potvrdi lozinku',
    'Obavezna_potvrda_lozinke': 'Potvrdite lozinku',
    'Lozinke_se_moraju_podudarati': 'Lozinke se moraju podudarati',
    'Validacija_naloga': 'Validacija naloga',
    'Ime': 'Ime',
    'Ime_obavezno': 'Ime je obavezno',
    'Prezime': 'Prezime',
    'Prezime_obavezno': 'Prezime je obavezno',
    'Telefonski_broj': 'Telefonski broj',
    'Telefonski_broj_obavezan': 'Telefonski broj je obavezan',
    'Telefonski_broj_nije_validan': 'Telefonski broj nije ispravan',
    'Email': 'Email',
    'Email_obavezan': 'Email je obavezan',
    'Godina_rodjenja': 'Godina rođenja',
    'Godina_rodjenja_obavezna': 'Godina rođenja je obavezna',
    'Spol': 'Spol',
    'Validacija_naloga_obavezna': 'Način validacije naloga je obavezan',
    'Prijavi_se': 'Prijavi se',
    'Spol_obavezan': 'Spol je obavezan',
    'Organizaciona_jedinica': 'Organizacijska jedinica',
    'Organizaciona_jedinica_obavezna': 'Organizacijska jedinica je obavezna',
    'Nadredena_organizaciona_jedinica': 'Nadređena organizacijska jedinica',
    'Uredi': 'Uredi',
    'forbidden': 'Zabranjeno!',
    'dogodila_se_greska': 'Dogodila se greška!',
    'poruka_sistema': 'Poruka sistema: ',
    'sesija_istekla': 'Vaša sesija je istekla, molimo prijavite se ponovo na sistem!',
    'zahtjev_za_web_servis_pogresan': 'Zahtjev za web servis nije pravilno formulisan!',
    'servis_nedostupan': 'Servis nije dostupan!',
    'metoda_nije_dozvoljena': 'Metoda nije dozvoljena!',
    'korisnicko_ime_obavezna_duzina': 'Korisničko ime mora imati 8 karaktera',
    'applicationtypeid_obavezan': 'ApplicationTypeId obavezan',
    'Naslov_obavezan': 'Naslov je obavezan',
    'Opis_obavezan': 'Opis je obavezan',
    'naziv_dokumenta_obavezan': 'Naziv dokumenta je obavezan',
    'nedostaje_ekstenzija': 'Nedostaje ekstenzija dokumenta',
    'tip_dokumenta_obavezan': 'Tip dokumenta obavezan',
    'redoslijed_obavezan': 'Redoslijed je obavezan',
    'nedostaje_aktivan': 'Nedostaje podatak da li je zapis aktivan',
    'tekst_obavezan': 'Tekst je obavezan',
    'naziv_obavezan': 'Naziv je obavezan',
    'nije_odabran_jezik': 'Nije odabran jezik',
    'id_obavezan': 'ID je obavezan',
    'morate_se_prijaviti_prijava_problema': 'Morate se prijaviti na sistem da biste prijavili problem!',
    'Profil': 'Profil',
    'Profil_obavezan': 'Profil je obavezan',
    'Organizaciona_jedinica_funkcija': 'Funkcija unutar organizacijske jedinice',
    'Organizaciona_jedinica_funkcija_obavezna': 'Funkcija unutar organizacijske jedinice je obavezna',
    'Obrisi': 'Obriši',
    'uspjesno_obrisan_tekst': 'Uspješno obrisan tekst',
    'uspjesno_obrisan_dokument': 'Uspješno obrisan dokument',
    'email_neispravan': 'Email adresa nije u ispravnom formatu',
    'potvrdi': 'Potvrdi',
    'pitanje_brisanje_info_teksta': 'Da li ste sigurni da želite izbrisati info tekst',
    'potvrda_brisanja_info_teksta': 'Potvrda brisanja info teksta',
    'pitanje_brisanje_info_dokumenta': 'Da li ste sigurni da želite izbrisati info dokument',
    'potvrda_brisanja_info_dokumenta': 'Potvrda brisanja info dokumenta',
    'Promijeni_lozinku': 'Promijeni lozinku',
    'Akcija': 'Akcija',
    'uspjesno_promijenjena_lozinka': 'Uspješno ste promijenili lozinku',
    'administracija': 'Administracija',
    'sifrarnici': 'Šifrarnici',
    'korisnici': 'Korisnici',
    'lista_korisnika': 'Lista korisnika',
    'unos_novog_korisnika': 'Unos novog korisnika',
    'izmjena_korisnika': 'Izmjena korisnika',
    'korisnici_rest_servisa': 'Korisnici REST servisa',
    'offline_javne_rasprave': 'Offline javne rasprave',
    'lista_offline_javnih_rasprava': 'Lista offline javnih rasprava',
    'unos_nove_offline_javne_rasprave': 'Unos nove offline javne rasprave',
    'izmjena_offline_javne_rasprave': 'Izmjena offline javne rasprave',
    'lista_korisnika_rest_servisa': 'Lista korisnika REST servisa',
    'unos_novog_korisnika_rest_servisa': 'Unos novog korisnika REST servisa',
    'izmjena_korisnika_rest_servisa': 'Izmjena korisnika REST servisa',
    'organizacione_jedinice': 'Organizacijske jedinice',
    'lista_organizacionih_jedinica': 'Lista organizacijskih jedinica',
    'unos_nove_organizacione_jedinice': 'Unos nove organizacijske jedinice',
    'izmjena_organizacione_jedinice': 'Izmjena organizacijske jedinice',
    'funkcije_organizacione_jedinice': 'Funkcije organizacijske jedinice',
    'lista_funkcija_organizacione_jedinice': 'Lista funkcija organizacijske jedinice',
    'unos_nove_funkcije_org_jedinice': 'Unos nove funkcije organizacijske jedinice',
    'izmjena_funkcije_org_jedinice': 'Izmjena funkcije organizacijske jedinice',
    'kategorije': 'Kategorije',
    'lista_kategorija': 'Lista kategorija',
    'unos_nove_kategorije': 'Unos nove kategorije',
    'izmjena_kategorije': 'Izmjena kategorije',
    'tipovi_sesije_javne_rasprave': 'Tipovi sesije javne rasprave',
    'lista_tipova_sesije_javne_rasprave': 'Lista tipova sesije javne rasprave',
    'unos_novog_tipa_sesije_javne_rasprave': 'Unos novog tipa sesije javne rasprave',
    'izmjena_tipa_sesije_javne_rasprave': 'Izmjena tipa sesije javne rasprave',
    'osjetljive_kategorije': 'Osjetljive kategorije',
    'lista_osjetljivih_kategorija': 'Lista osjetljivih kategorija',
    'unos_nove_osjetljive_kategorije': 'Unos nove osjetljive kategorije',
    'izmjena_osjetljive_kategorije': 'Izmjena osjetljive kategorije',
    'tipovi_dokumenta': 'Tipovi dokumenta',
    'lista_tipova_dokumenta': 'Lista tipova dokumenta',
    'unos_novog_tipa_dokumenta': 'Unos novog tipa dokumenta',
    'izmjena_tipa_dokumenta': 'Izmjena tipa dokumenta',
    'info_section': 'Info sekcija',
    'info_section_texts_list': 'Lista tekstova info sekcije',
    'unos_novog_teksta_info_sekcije': 'Unos novog teksta info sekcije',
    'izmjena_teksta_info_sekcije': 'Izmjena teksta info sekcije',
    'lista_dokumenata_info_sekcije': 'Lista dokumenata info sekcije',
    'unos_novog_dokumenta_info_sekcije': 'Unos novog dokumenta info sekcije',
    'izmjena_dokumenta_info_sekcije': 'Izmjena dokumenta info sekcije',
    'pocetna': 'Početna',
    'prituzbe': 'Pritužbe',
    'prijava_problema': 'Prijava problema',
    'Vrsta prijave': 'Vrsta prijave',
    'Polje za registraciju': 'Polje za registraciju',
    'Vidljivo': 'Vidljivo',
    'Obavezno': 'Obavezno',
    'Godina_rodjenja_obavezan': 'Godina rođenja je obavezna',
    'Osjetljiva_kategorija': 'Osjetljiva kategorija',
    'Osjetljiva_kategorija_obavezna': 'Osjetljiva kategorija je obavezna',
    'Reset_': 'Poništi',
    'Filtriraj_': 'Pretraži',
    'Iskljuci_filter': 'Isključi filter',
    'Ukljuci_filter': 'Uključi filter',
    'konfiguracija-sistemskih-parametara': 'Konfiguracija sistemskih parametara',
    'obavezna-polja-za-registraciju': 'Obavezna polja za registraciju',
    'odabir-vrste-prijave': 'Odabir vrste prijave',
    'konfiguracija-prituzbi': 'Konfiguracija pritužbi',
    'lista-podnesenih-prituzbi': 'Lista podnesenih pritužbi',
    'Problem': 'Problem',
    'Kategorija': 'Kategorija',
    'Datum': 'Datum',
    'Status': 'Status',
    'korisnik': 'Korisnik',
    'kategorija_obavezna': 'Kategorija je obavezna',
    'izaberi_dokument': 'Izaberi dokument',
    'dodaj_dokumente': 'Dodaj dokumente',
    'uspjesno_ucitano': 'Uspješno učitano',
    'ucitavanje_nije_uspjelo': 'Učitavanje nije uspjelo',
    'uredjivanje_prituzbe': 'Uređivanje pritužbe',
    'detalji_prituzbe': 'Detalji pritužbe',
    'Slike': 'Slike',
    'Lokacija': 'Lokacija',
    'Komentari': 'Komentari',
    'Dodijeljen': 'Dodijeljen',
    'Neodgovarajuca': 'Neprimjerena',
    'Dodijeli': 'Dodijeli',
    'dodijeli_i_postavi_kao_vidljivo': 'Dodijeli i postavi kao vidljivo',
    'Promijeni_status': 'Promijeni status',
    'Novi_komentar': 'Novi komentar',
    'Sacuvaj': 'Sačuvaj',
    'Komentar': 'Komentar',
    'Komentar_kreirao': 'Komentar kreirao',
    'Fajl': 'Fajl',
    'Datum_vrijeme': 'Datum i vrijeme',
    'Odabir_statusa_obavezan': 'Odabir statusa je obavezan',
    'Unos_komentara_obavezan': 'Unos komentara је obavezan',
    'Odabir_organizacije_obavezan': 'Odabir organizacije je obavezan',
    'dokumenti_nisu_uploadovani': 'Dokumenti nisu uspješno uploadovani!',
    'opis_lokacije': 'Opis lokacije',
    'nastavi': 'Nastavi',
    'odaberi_sliku': 'Odaberi sliku',
    'zavrsi': 'Završi',
    'uspjesna_prijava_problema': 'Uspješno ste prijavili problem',
    'uspjesno_snimanje_slike': 'Uspješno ste snimili sliku',
    'lista_konfiguracijskih_parametara': 'Lista konfiguracijskih parametara',
    'uredjivanje_konfiguracijskih_parametara': 'Uređivanje konfiguracijskog parametra',
    'lista-mojih-prituzbi': 'Lista mojih podnesenih pritužbi',
    'uspjesno_obrisan_fajl': 'Uspješno ste obrisali fajl',
    'Prijavi_problem': 'PRIJAVI PROBLEM',
    'moja-prituzba': 'Moja pritužba',
    'Neodgovarajuci_sadrzaj': ' Ova pritužba se ne prikazuje zbog neprimjerenog sadržaja',
    'odabir-vrste-verifikacije-registracije': 'Odabir vrste verifikacije registracije',
    'Nacin_slanja': 'Način slanja',
    'notifikacije_poslate_od_strane_korisnika': 'Notifikacije poslate od strane korisnika',
    'lista_notifikacija_poslatih_od_strane_korisnika': 'Lista notifikacija poslatih od strane korisnika',
    'notifikacije': 'Notifikacije',
    'unos_nove_notifikacije': 'Unos nove notifikacije',
    'izmjena_notifikacije': 'Izmjena notifikacije',
    'pitanje_brisanje_notifikacija': 'Da li ste sigurni da želite izbrisati notifikaciju',
    'potvrda_brisanja_notifikacija': 'Potvrda brisanja notifikacije',
    'uspjesno_obrisana_notifikacija': 'Notifikacija je uspješno obrisana',
    'uspjesno_snimljen_odgovor': 'Odgovor je uspješno snimljen',
    'uspjesno_snimljeno': 'Uspješno snimljeno',
    'user_already_exists': 'Korisničko ime već postoji u sistemu',
    'incorrect_username_or_password': 'Pogrešno korisničko ime ili šifra',
    'email_not_valid_format': 'Email adresa nije u ispravnom formatu',
    'unable_to_send_email_check_email': 'Aktivacijski kod nije poslat na email. Provjerite unesenu email adresu.',
    'unable_to_send_sms_check_telephone_number': 'Aktivacijski kod nije poslat sms-om. Provjerite uneseni broj telefona.',
    'telefon_neispravan': 'Telefonski broj nije u ispravnom formatu.',
    'Kod_obavezan': 'Kod je obavezan',
    'potvrda_registarcije_email': 'Molimo Vas potvrdite registraciju klikom na link koji ste dobili na email!',
    'Slanje_not_SMS_om': 'Slanje obavještenja SMS-om',
    'Slanje_not_Email_om': 'Slanje obavještenja Email-om',
    'Slanje_not_Push_om': 'Slanje obavještenja Push notifikacijama',
    'sms': 'SMS',
    'email': 'Email',
    'push': 'Push',
    'sistemske-notifikacije': 'Sistemske notifikacije',
    'sistemske-notifikacije-lista': 'Lista sistemskih notifikacija',
    'sistemske-notifikacije-detalji': 'Detalji sistemske notifikacije',
    'Vrijednost': 'Vrijednost',
    'Neodgovarajuci': 'Neprimjeren',
    'Oznaci_kao_vidljivo': 'Označi kao vidljivo',
    'Snimi': 'Snimi',
    'Odgovor': 'Odgovor',
    'Unos_odgovora_obavezan': 'Unos odgovora je obavezan',
    'Sacuvaj_odgovor': 'Sačuvaj odgovor',
    'Fajl_odgovora': 'Fajl odgovora',
    'Dodavanje_fajla': 'Dodavanje fajla',
    'Korisnik': 'Korisnik',
    'Potvrdi': 'Potvrdi',
    'godina_rodjenja_mora_biti_manji_od_trenutne': 'Godina rođenja mora biti manja ili jednaka trenutnoj!',
    'uspjesno_ste_potvrdili_registraciju': 'Uspješno ste potvrdili registraciju! Ukoliko želite da nastavite koristiti eCitizen aplikaciju kao registrovani korisnik kliknite na dugme "Potvrdi"!',
    'varification_code_not_valid': 'Kod za verifikaciju registracije nije ispravan!',
    'Odaberi_primaoce': 'Odaberi primaoce',
    'Ponovo_posalji_email': 'Ponovo pošalji email',
    'Ponovo_posalji_sms': 'Ponovo pošalji SMS',
    'kod_ponovo_poslan_putem_sms_poruke': 'Verifikacijski kod ponovo poslat putem SMS poruke!',
    'verifikacijski_mail_ponovo_poslan': 'Verifikacijski email ponovo poslat!',
    'Datum_slanja': 'Datum slanja',
    'Poslato': 'Poslato',
    'incorrect_old_password': 'Pogrešna stara lozinka',

    'uspjesna_odjava': 'Uspješno ste se odjavili',
    'Nacin_slanja_obavezan': 'Odabir načina slanja je obavezan',
    'promijeni_lozinku': 'Promjena lozinke',
    'promijeni_lozinku_korisnika_rest_servisa': 'Promijeni lozinku korisnika rest servisa',
    'info_sekcija': 'Info sekcija',
    'lista_tekstova_info_sekcije': 'Lista tekstova info sekcije',
    'info_dokumenti': 'Info dokumenti',
    'Vrijeme_odgovora': 'Vrijeme odgovora',
    'Starost': 'Starost',
    'Broj_prituzbe': 'Broj pritužbe',
    'Datum_prituzbe': 'Datum pritužbe',
    'Ime_Prezime': 'Ime i prezime',
    'Autor': 'Autor',
    'izvjestaji': 'Izvještaji',
    'prituzbe_zadati_vremenski_okvir': 'Lista prijavljenih pritužbi u zadatom vremenskom okviru',
    'prituzbe_vrijeme_odgovora': 'Vrijeme odgovora (Prosječno, Maksimalno, Minimalno)',
    'prituzbe_kategorija_status': 'Lista prijavljenih pritužbi po kategoriji i statusu',
    'prituzbe_profilni_podaci': 'Lista prijavljenih pritužbi po profilnim podacima',
    'prituzbe_datum_rjesavanja': 'Lista prijavljenih pritužbi po datumu rješavanja pritužbe',
    'Datum_kreiranja_od': 'Datum kreiranja od',
    'Datum_kreiranja_do': 'Datum kreiranja do',
    'Tip': 'Tip',
    'Pretraga': 'Pretraga',
    'Nazad': 'Nazad',
    'Datum_rjesavanja': 'Datum rješavanja',
    'Datum_rjesavanja_od': 'Datum rješavanja od',
    'Datum_rjesavanja_do': 'Datum rješavanja do',
    'Datum_izmjene': 'Datum izmjene',
    'Datum_kreiranja': 'Datum kreiranja',
    'sve_prituzbe': "Sve pritužbe",
    'statistika': 'Statistika',
    'javne_rasprave': 'Javne rasprave',
    'online_јavne_rasprave': 'Online јavne rasprave',
    'Datum_pocetka': 'Datum početka',
    'Datum_kraja': 'Datum kraja',
    'Status_javne_rasprave_obavezan': 'Status javne rasprave je obavezan',
    'Privilegije_obavezno': 'Privilegije su obavezne',
    'Datum_pocetka_obavezan': 'Datum početka je obavezan',
    'Datum_kraja_obavezan': 'Datum kraja je obavezan',
    'Aktivan_obavezno': 'Aktivana je obavezno',
    'Pretrage_obavezna': 'Pretraga je obavezna',
    'Status_podataka_obavezan': 'Status podataka je obavezan',
    'Kategorije_javne_rasprave_obavezana': 'Kategorije javne rasprave je obavezna',
    'Privilegije': 'Privilegije',
    'Odabir_privilegije_obavezan': 'Odabir privilegije je obavezan',
    'tip_dokumenta': 'Tip dokumenta',
    'Generisi_izvjestaj': 'Generiši izvještaj',
    'kategorije_javnih_rasprava': 'Kategorije javnih rasprava',
    'lista_kategorija_javnih_rasprava': 'Lista kategorija javnih rasprava',
    'unos_nove_kategorije_javne_rasprave': 'Unos nove kategorije javne rasprave',
    'izmjena_kategorije_javne_rasprave': 'Izmjena kategorije javne rasprave',
    'Pocetak': 'Početak',
    'Kraj': 'Kraj',
    'Broj_ucesnika': 'Broj učesnika',
    'Broj_ucesnika_filter': 'Broj učesnika prema odabranom filteru',
    'lista_sesija_offline_javne_rasprave': 'Lista sesija offline javne rasprave',
    'izmjena_sesije_offline_javne_rasprave': 'Izmjena sesije offline javne rasprave',
    'unos_nove_sesije_offline_javne_rasprave': 'Unos nove sesije offline javne rasprave',
    'Vrsta': 'Vrsta',
    'Odabir_vrste_javne_rasprave_obavezan': 'Odabir vrste javne rasprave',
    'Datum_zadnje_izmjene': 'Datum zadnje izmjene',
    'sjednice': 'Sjednice',
    'lista_sjednica': 'Lista sjednica',
    'unos_nove_sjednice': 'Unos nove sjednice',
    'izmjena_sjednice': 'Izmjena sjednice',
    'datum_pocetka_sjednice': 'Datum početka',
    'tacke_dnevnog_reda': 'Tačke dnevnog reda',
    'izmjena_tacke_dnevnog_reda': 'Izmjena tačke dnevnog reda',
    'unos_nove_tacke_dnevnog_reda': 'Unos nove tačke dnevnog reda',
    'Pravo_pristupa': 'Pravo pristupa',
    'Glasova_za': 'Glasova građana za',
    'Glasova_protiv': 'Glasova građana protiv',
    'Omoguceno_glasanje': 'Omogućeno glasanje',
    'Omoguceno_komentarisanje': 'Omogućeno komentarisanje',
    'podaci_nisu_snimljeni_nepoznat_entityStatus': 'Podaci nisu snimljeni! Nepoznat entityStatus.',
    'Kontakt_osobe': 'Kontakt osobe',
    'Funkcija': 'Funkcija',
    'Odgovorne_osobe': 'Odgovorne osobe',
    'Offline_javna_rasprava': 'Offline javna rasprava',
    'Minimalno_vrijeme_odgovora': 'Minimalno vrijeme odgovora',
    'Maksimalno_vrijeme_odgovora': 'Maksimalno vrijeme odgovora',
    'Prosjecno_vrijeme_odgovora': 'Prosječno vrijeme odgovora',
    'Ukupan_broj_prituzbi': 'Ukupan broj pritužbi',

    'Javna_rasprava_obavezno': 'Javna rasprava je obavezna',
    'Tip_sesije_obavezan': 'Vrsta sesije je obavezna',
    'Datum_sesije_obavezan': 'Datum je obavezan',
    'Vrijeme_pocetka_sesije_obavezno': 'Vrijeme početka je obavezno',
    'Broj_muskih_ucesnika_obavezan': 'Broj muških učesnika je obavezan',
    'Broj_zenskih_ucesnika_obavezan': 'Broj ženskih učesnika je obavezan',
    'Status_sesije_obavezan': 'Status sesije je obavezan',
    'Lokacija_sesije_obavezna': 'Lokacija je obavezna',
    'Lokacija_sesije': 'Lokacija sesije',
    'Vrijeme_pocetka': 'Vrijeme početka',
    'Vrijeme_zavrsetka': 'Vrijeme završetka',
    'Broj_muskih_ucesnika': 'Broj muških učesnika',
    'Broj_zenskih_ucesnika': 'Broj ženskih učesnika',
    'Tip_sesije': 'Vrsta',
    'Vrijeme_pocetka_sesije_nije_validno': 'Vrijeme početka nije validno',
    'Vrijeme_zavrsetka_sesije_nije_validno': 'Vrijeme završetka nije validno',
    'Stara_lozinka': 'Stara lozinka',
    'Nova_lozinka': 'Nova lozinka',
    'Promijeni_podatke': 'Promijeni podatke',
    'Odjavi_se': 'Odjavi se',
    'Aktivna': 'Aktivna',
    'Potvrda_brisanja': 'Potvrda brisanja',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_kontakt_osobu': 'Da li ste sigurni da želite da obrišete kontakt osobu',
    'Kontakt_osoba_je_uspjesno_obrisana': 'Kontakt osoba je uspješno obrisana',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_odgovornu_osobu': 'Da li ste sigurni da želite da obrišete odgovornu osobu',
    'Odgovorna_osoba_je_uspjesno_obrisana': 'Odgovorna osoba je uspješno obrisana',
    'Stara_lozinka_obavezna': 'Stara lozinka je obavezna',
    'Offline_javna_rasprava_ne_postoji': 'Offline javna rasprava ne postoji',
    'File_ne_postoji': 'Dokument nije pronađen',
    'Osobe': 'Osobe',
    'Lista_osoba': 'Lista osoba',
    'Unos_nove_osobe': 'Unos nove osobe',
    'Izmjena_osobe': 'Izmjena osobe',
    'Dodaj_odgovornu_osobu': 'Dodaj odgovornu osobu',
    'Dodaj_kontakt_osobu': 'Dodaj kontakt osobu',
    'Zatvori': 'Zatvori',
    'Dokumenti': 'Dokumenti',
    'Preuzmi': 'Preuzmi',
    'Dodaj_dokument': 'Dodaj dokument',
    'Uredi_dokument': 'Uredi dokument',
    'Dokument_obavezan': 'Dokument je obavezan',
    'Korisnicko_ime_min_duzina': 'Minimalna dužina korisničkog imena je 4 karaktera',
    'Korisnicko_ime_max_duzina': 'Maksimalna dužina korisničkog imena je 15 karaktera',
    'email_already_exists': 'Unesena email adresa već postoji u sistemu',
    'telephone_number_already_exists': 'Uneseni telefonski broj već postoji u sistemu',
    'broj_telefona_obavezan': 'Broj telefona je obavezan',
    'Kreirao': 'Kreirao',
    'Uploadovani_dokument_nije_pronadjen': 'Uploadovani dokument nije pronađen',
    'Uploadovani_dokument_nije_validan': 'Uploadovani dokument nije validan. Dokument mora biti u jednom od navedenih formata: .pdf,.doc,.docx,.jpeg,.jpg,.mov,.png,.bmp,.xlsx,.xls',
    'Uploadovani_fajl_komentara_nije_validan': 'Komentar je sačuvan bez fajla. Podržani formati fajlova su: .pdf,.doc,.docx,.jpeg,.jpg,.mov,.png,.bmp,.xlsx,.xls',
    'Deaktivacija_profila': 'Deaktivacija profila',
    'Deaktivacija_profila_poruka': 'Deaktivacijom profila više nećete biti u mogućnosti da pristupite Vašem nalogu i njegovom sadržaju. Sav Vaš uneseni sadržaj će i dalje ostati u sistemu. Da li ste sigurni da želite da deaktivirate profil?',
    'Zaboravili_ste_korisnicko_ime_ili_lozinku': 'Zaboravili ste korisničko ime ili lozinku?',
    'poslat_mejl_sa_novom_lozinkom': 'Korisničko ime i nova lozinka su poslati na Vašu e-mail adresu.',
    'unable_to_find_user_with_entered_email': 'Korisnik sa unesenom email adresom nije pronađen u sistemu.',
    'slanje_nije_uspjelo': 'Slanje nije uspjelo.',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_dokument': 'Da li ste sigurni da želite da obrišete dokument',
    'Dokument_je_uspjesno_obrisan': 'Dokument je uspješno obrisan',
    'izmjena_dokumenta': 'Izmjena dokumenta',
    'unos_novog_dokumenta': 'Unos novog dokumenta',
    'unos_novog_dodatnog_materijala': 'Unos novog dodatnog materijala/obavijesti',
    'izmjena_dodatnog_materijala': 'Izmjena dodatnog materijala/obavijesti',
    'datum_zavrsetka_sjednice': 'Datum završetka',
    'status_sjednice_obavezan': 'Status sjednice je obavezan',
    'pravo_pristupa_obavezno': 'Pravo pristupa je obavezno',
    'datum_pocetka_sjednice_obavezan': 'Datum početka je obavezan',
    'status_tacke_dnevnog_reda_obavezan': 'Status tačke dnevnog reda je obavezan',
    'Dodaj_sesiju': 'Dodaj sesiju',
    'Token_uredjaja': 'Token uređaja',
    'vrijeme_pocetka_sjednice_obavezno': 'Vrijeme početka je obavezno',
    'vrijeme_pocetka_sjednice_nije_validno': 'Vrijeme početka nije validno',
    'vrijeme_zavrsetka_sjednice_nije_validno': 'Vrijeme završetka nije validno',
    'dokument_uspjesno_obrisan': 'Dokument uspješno obrisan',
    'Dodaj_pitanje': 'Dodaj pitanje',
    'Uredi_pitanje': 'Uredi pitanje',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_pitenje': 'Da li ste sigurni da želite obrisati pitanje',
    'Pitanje_je_uspjesno_obrisano': 'Pitanje je uspješno obrisano',
    'Pitanja_i_odgovori': 'Pitanja i odgovori',
    'Pitanje': 'Pitanje',
    'Jls_Kontakt': 'JLS kontakt',
    'Gradjanin': 'Građanin',
    'Aktivno': 'Aktivno',
    'Pitanje_je_obavezno': 'Pitanje je obavezno',
    'Odgovor_je_preveliki': 'Odgovor je preveliki',
    'Jls_Kontakt_nije_validan': 'JLS kontakt nije ispravan',
    'Gradjanin_je_obavezan': 'Građanin je obavezan',
    'Email_nije_validan': 'Email nije ispravan',
    'Pitanje_ne_postoji': 'Pitanje ne postoji',
    'detalji_sjednice': 'Detalji sjednice',
    'detalji_tacke_dnevnog_reda': 'Detalji tačke dnevnog reda',
    'online_javne_rasprave': 'Online javne rasprave',
    'lista_online_javnih_rasprava': 'Lista online javnih rasprava',
    'Prijavite se na nas newsletter': 'Prijavite se na naš newsletter',
    'uspjesna_prijava_na_newsletter': 'Uspješno ste se prijavili na newsletter',
    'Posalji': 'Pošalji',
    'pitanje_newsletter_slanje': 'Da li ste sigurni da želite poslati notifikaciju korisnicima prijavljenim na newsletter',
    'potvrda_newsletter_slanje': 'Potvrda slanja newsletter-a',
    'uspjesno_poslata_notifikacija_na_newsletter': 'Notifikacija je uspješno poslata',
    'glasaj_za': 'Glasaj za',
    'glasaj_protiv': 'Glasaj protiv',
    'vote_already_added': 'Već ste glasali za ovu tačku dnevnog reda',
    'glasanje_uspjesno': 'Vaš glas je zaprimljen. Hvala što ste glasali!',
    'Godina_rodjenja_obavezna_duzina': 'Godina rođenja mora sadržati 4 karaktera',
    'unos_nove_online_javne_rasprave': 'Unos nove online javne rasprave',
    'izmjena_online_javne_rasprave': 'Izmjena online javne rasprave',
    'godina_rodjenja_se_sastoji_od_cetiri_cifre': 'Godina rođenja se mora sastojati od četiri cifre',
    'Uslovi_zahtjevi': 'Uslovi i zahtjevi',
    'Politika_privatnosti': 'Politika privatnosti',
    'Kontakti_za_pomoc': 'Kontakti za pomoć',
    'Korisnicko_uputstvo': 'Korisničko uputstvo',
    'naziv_tacke_dnevnog_reda': 'Naziv tačke dnevnog reda',
    'naziv_podtacke_dnevnog_reda': 'Naziv podtačke dnevnog reda',
    'Online_javna_rasprava': 'Online javna rasprava',
    'Dodaj_diskusiju': 'Dodaj diskusiju',
    'Diskusije': 'Diskusije',
    'lista_diskusija_online_javne_rasprave': 'Lista diskusija online javne rasprave',
    'izmjena_diskusije_online_javne_rasprave': 'Izmjena diskusije online javne rasprave',
    'unos_nove_diskusije_online_javne_rasprave': 'Unos nove diskusije online javne rasprave',
    'Posalji_izvjestaj': 'Pošalji izvještaj',
    'Finalni_izvjestaj': 'Finalni izvještaj',
    'nedostaje_dokument': 'Nedostaje dokument',
    'sazivi': 'Sazivi',
    'lista_saziva': 'Lista saziva',
    'trenutni_saziv': 'Trenutni saziv',
    'unos_novog_saziva': 'Unos novog saziva',
    'datum_pocetka_saziva': 'Datum početka saziva',
    'datum_zavrsetka_saziva': 'Datum završetka saziva',
    'datum_pocetka_saziva_obavezan': 'Datum početka saziva je obavezan',
    'datum_zavrsetka_saziva_obavezan': 'Datum završetka saziva je obavezan',
    'izmjena_saziva': 'Izmjena saziva',
    'politicke_partije': 'Političke partije',
    'lista_politickih_partija': 'Lista političkih partija',
    'unos_nove_politicke_partije': 'Unos nove političke partije',
    'izmjena_politicke_partije': 'Izmjena političke partije',
    'skraceni_naziv': 'Skraćeni naziv',
    'politicka_partija': 'Politička partija',
    'skraceni_naziv_obavezan': 'Skraćeni naziv je obavezan',
    'saziv': 'Saziv',
    'Sesija_offline_javne_rasprave_ne_postoji': 'Sesija offline javne rasprave ne postoji',
    'Diskusija_online_javne_rasprave_ne_postoji': 'Diskusija online javne rasprave ne postoji',
    'Komentar_ne_postoji': 'Komentar ne postoji',
    'Naziv_diskusije_je_obavezan': 'Naziv diskusije je obavezan',
    'To_obavezno': 'To je obavezno',
    'Slanje_finalnog_izvjestaja_za_sesiju_ofline_javne_rasprave': 'Slanje finalnog izvještaja za sesiju ofline javne rasprave',
    'To': 'To',
    'Cc': 'Cc',
    'Subject': 'Naslov poruke',
    'Subject_obavezno': 'Naslov poruke je obavezan',
    'Message': 'Tekst poruke',
    'Message_obavezan': 'Tekst poruke je obavezan',
    'finalni_izvjestaj_je_uspjesno_poslat': 'Finalni izvještaj je uspješno poslat!',
    'finalni_izvjestaj_nije_uspjesno_poslat': 'Finalni izvještaj nije uspješno poslat. Pokušajte ponovo!',
    'Datum_diskusije_obavezan': 'Datum diskusije je obavezan',
    'tip_clana': 'Tip člana',
    'kratka_biografija': 'Kratka biografija',
    'tip_clana_obavezan': 'Tip člana je obavezan',
    'politicka_partija_obavezna': 'Politička partija je obavezna',
    'saziv_obavezan': 'Saziv je obavezan',
    'korisnik_obavezan': 'Korisnik je obavezan',
    'slika_obavezna': 'Slika je obavezna',
    'kratka_biografija_obavezna': 'Kratka biografija je obavezna',
    'sve_sjednice': 'Sve sjednice',
    'Odaberi': 'Odaberi',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_poveznicu': 'Da li ste sigurni da želite da obrišete poveznicu',
    'Poveznica_je_uspjesno_obrisana': 'Poveznica je uspješno obrisana',
    'Poveznice': 'Poveznice',
    'Poveznica': 'Poveznica',
    'Dodaj_poveznicu_na_sjednicu': 'Dodaj poveznicu na sjednicu',
    'Dodaj_poveznicu_na_prituzbu': 'Dodaj poveznicu na pritužbu',
    'Dodavanje_poveznice_na_sjednicu': 'Dodavanje poveznice na sjednicu',
    'Dodavanje_poveznice_na_prituzbu': 'Dodavanje poveznice na pritužbu',
    'Sjednica': 'Sjednica',
    'detalji_pitanja': 'Detalji pitanja',
    'ime_prezime': 'Ime i prezime',
    'broj_pitanja': 'Broj pitanja',
    'broj_odgovora': 'Broj odgovora',
    'detalji_offline_javne_rasprave': 'Detalji offline javne rasprave',
    'pitanje_postavio': 'Pitanje postavio',
    'datum_pitanja': 'Datum pitanja',
    'pitanja_clanu_saziva': 'Pitanja članu saziva',
    'pitanje': 'Pitanje',
    'odgovor': 'Odgovor',
    'pitanja': 'Pitanja',
    'pitanje_aktivno': 'Pitanje aktivno',
    'odgovor_aktivan': 'Odgovor aktivan',
    'Tacka_dnevnog_reda': 'Tačka dnevnog reda',
    'Broj_glasanja': 'Broj glasanja',
    'Broj_komentara': 'Broj komentara',
    'komentari_glasovi_tacaka_dnevnog_reda': 'Broj komentara i glasanja po tačkama dnevnog reda',
    'komentari_glasovi_sjednica': 'Broj komentara i glasanja po sjednicama',
    'tekst_pitanja': 'Tekst pitanja',
    'odgovorio': 'Odgovorio',
    'datum_odgovora': 'Datum odgovora',
    'tekst_odgovora': 'Tekst odgovora',
    'neprimjereno': 'Neprimjereno',
    'nacin_unosa_odgovora': 'Način unosa odgovora',
    'postavi_pitanje': 'POSTAVI PITANJE',
    'unesite_tekst_pitanja': 'Unesite tekst pitanja',
    'tekst_pitanja_obavezan': 'Tekst pitanja je obavezan',
    'tekst_odgovora_obavezan': 'Tekst odgovora je obavezan',
    'nema_odgovora': 'Nema odgovora',
    'Datum_pocetka_od': 'Datum početka od',
    'Datum_pocetka_do': 'Datum početka do',
    'Prituzbe': 'Pritužbe',
    'Sjednice_opstinskih_vijeca': 'Sjednice',
    'Vijecnici_nacelnici_gradonacelnici': 'Pitanja',
    'Javne_rasprave': 'Javne rasprave',
    'pitanja_vijecnika_po_statusu': 'Broj pitanja po statusima (Odgovoreni, Neodgovoreni)',
    'broj_odgovorenih_pitanja': 'Broj odgovorenih pitanja',
    'broj_neodgovorenih_pitanja': 'Broj neodgovorenih pitanja',
    'ukupno_pitanja': 'Ukupno pitanja',
    'moja_pitanja': 'Moja pitanja',
    'pitanja_za_nacelnika': 'Pitanja za načelnika',
    'pitanja_za_odbornika': 'Pitanja za vijećnike',
    'pitanja_za_moju_administrativnu_jedinicu': 'Pitanja postavljena mojoj organizacijskoj jedinici',
    'pitanja_za_organizacione_jedinice': 'Pitanja za organizacione jedinice',
    'datum_pitanja_od': 'Datum pitanja od',
    'datum_pitanja_do': 'Datum pitanja do',
    'izmijeni_profil': 'Izmijeni profilne podatke',
    'detalji_profila': 'Detalji profila',
    'Detalji': 'Detalji',
    'Detalji_sesije': 'Detalji sesije',
    'detalji_online_javne_rasprave': 'Detalji online javne rasprave',
    'pitanje_zaprimljeno': 'Pitanje je uspješno zaprimljeno',
    'uspjesno_odgovoreno': 'Odgovor je uspješno dodat',
    'morate_se_prijaviti_postavljanje_pitanja': 'Morate se prijaviti na sistem da biste postavili pitanje!',
    'Kreirano': 'Kreirano',
    'Izmijenjeno': 'Izmijenjeno',
    'detalji_diskusije_online_javne_rasprave': 'Detalji diskusije online javne rasprave',
    'Opis_diskusije': 'Opis diskusije',
    'Datum_diskusije': 'Datum diskusije',
    'Naziv_diskusije': 'Naziv diskusije',
    'Datum_kraja_online_javne_rasprave': 'Datum kraja online javne rasprave',
    'Datum_pocetka_online_javne_rasprave': 'Datum početka online javne rasprave',
    'broj_pitanja_po_polu': 'Broj pitanja po profilnim podacima (rodna pripadnost)',
    'muski_pol': 'Muški pol',
    'zenski_pol': 'Ženski pol',
    'nepoznato': 'Nepoznato',
    'Datum_pitanja_od': 'Datum pitanja od',
    'Datum_pitanja_do': 'Datum pitanja do',
    'broj_pitanja_po_kategoriji': 'Broj pitanja po profilnim podacima (osjetljiva kategorija)',
    'detalji_sesije_offline_javne_rasprave': 'Detalji sesije offline javne rasprave',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_offline_debatu': 'Da li ste sigurni da želite da obrišete offline javnu raspravu',
    'Offline_debata_je_uspjesno_obrisana': 'Offline javna rasprava je uspješno obrisana',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_online_debatu': 'Da li ste sigurni da želite da obrišete online javnu raspravu',
    'Online_debata_je_uspjesno_obrisana': 'Online javna rasprava je uspješno obrisana',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_sesiju_offline_debatu': 'Da li ste sigurni da želite da obrišete sesiju',
    'Sesija_offline_debate_je_uspjesno_obrisana': 'Sesija je uspješno obrisana',
    'Da_li_ste_sigurni_da_zelite_da_obrisete_diskusiju_online_debatu': 'Da li ste sigurni da želite da obrišete diskusiju',
    'Diskusija_online_debate_je_uspjesno_obrisana': 'Diskusija je uspješno obrisana',
    'broj_pitanja_po_starosnim_grupama': 'Broj pitanja po profilnim podacima (starosna grupa)',
    'Jls_kontakt_email': 'JLS kontakt email',
    'Gradjanin_email': 'Građanin email',
    'pitanje_brisanje_korisnika': 'Da li ste sigurni da želite izbrisati korisnika',
    'potvrda_brisanja_korisnika': 'Potvrda brisanja korisnika',
    'uspjesno_obrisan_korisnik': 'Korisnik je uspješno obrisan',
    'brisanje_nije_moguce': 'Brisanje nije moguće',
    'pitanje_brisanje_osjetljive_kategorije': 'Da li ste sigurni da želite izbrisati osjetljivu kategoriju',
    'potvrda_brisanja_osjetljive_kategorije': 'Potvrda brisanja osjetljive kategorije',
    'uspjesno_obrisana_osjetljiva_kategorija': 'Osjetljiva kategorija je uspješno obrisana',
    'pitanje_brisanje_kategorije': 'Da li ste sigurni da želite izbrisati kategoriju',
    'potvrda_brisanja_kategorije': 'Potvrda brisanja kategorije',
    'uspjesno_obrisana_kategorija': 'Kategorija je uspješno obrisana',
    'pitanje_brisanje_saziva': 'Da li ste sigurni da želite izbrisati saziv',
    'potvrda_brisanja_saziva': 'Potvrda brisanja saziva',
    'uspjesno_obrisan_saziv': 'Saziv je uspješno obrisan',
    'pitanje_brisanje_politicke_partije': 'Da li ste sigurni da želite izbrisati političku partiju',
    'potvrda_brisanja_politicke_partije': 'Potvrda brisanja političke partije',
    'uspjesno_obrisana_politicka_partija': 'Politička partija je uspješno obrisana',
    'pitanje_brisanje_funkcije_organizacione_jedinice': 'Da li ste sigurni da želite izbrisati funkciju organizacijske jedinice',
    'potvrda_brisanja_funkcije_organizacione_jedinice': 'Potvrda brisanja funkcije organizacijske jedinice',
    'uspjesno_obrisana_funkcija_organizacione_jedinice': 'Funkcija organizacijske jedinice je uspješno obrisana',
    'pitanje_brisanje_tipa_dokumenta': 'Da li ste sigurni da želite izbrisati tip dokumenta',
    'potvrda_brisanja_tipa_dokumenta': 'Potvrda brisanja tipa dokumenta',
    'uspjesno_obrisan_tip_dokumenta': 'Tip dokumenta je uspješno obrisan',
    'pitanje_brisanje_tipa_sesije_javne_rasprave': 'Da li ste sigurni da želite izbrisati tip sesije javne rasprave',
    'potvrda_brisanja_tipa_sesije_javne_rasprave': 'Potvrda brisanja tipa sesije javne rasprave',
    'uspjesno_obrisan_tip_sesije_javne_rasprave': 'Tip sesije javne rasprave je uspješno obrisan',
    'pitanje_brisanje_kategorije_javnih_rasprava': 'Da li ste sigurni da želite izbrisati kategoriju javne rasprave',
    'potvrda_brisanja_kategorije_javnih_rasprava': 'Potvrda brisanja kategorije javne rasprave',
    'uspjesno_obrisana_kategorija_javnih_rasprava': 'Kategorija javne rasprave je uspješno obrisana',
    'pitanje_brisanje_zalbe': 'Da li ste sigurni da želite izbrisati pritužbu',
    'potvrda_brisanja_zalbe': 'Potvrda brisanja pritužbe',
    'uspjesno_obrisana_zalba': 'Pritužba je uspješno obrisana',
    'Datum_kraja_ne_moze_biti_manji_od_datum_pocetka': 'Datum kraja ne može biti manji od datum početka',
    'Odabrana_osoba_je_vec_dodata_kao_odgovorna_osoba': 'Odabrana osoba je već dodata kao odgovorna osoba',
    'Odabrana_osoba_je_vec_dodata_kao_kontakt_osoba': 'Odabrana osoba je već dodata kao kontakt osoba',
    'Odabrana_poveznica_na_sjednicu_je_vec_dodata': 'Odabrana poveznica na sjednicu je već dodata',
    'Odabrana_poveznica_na_prituzbu_je_vec_dodata': 'Odabrana poveznica na pritužbu je već dodata',
    'pitanje_brisanje_osobe': 'Da li ste sigurni da želite izbrisati osobu',
    'potvrda_brisanja_osobe': 'Potvrda brisanja osobe',
    'uspjesno_obrisana_osoba': 'Osoba je uspješno obrisana',
    'pitanje_brisanje_sjednice': 'Da li ste sigurni da želite izbrisati sjednicu',
    'potvrda_brisanja_sjednice': 'Potvrda brisanja sjednice',
    'uspjesno_obrisana_sjednica': 'Sjednica je uspješno obrisana',
    'pitanje_brisanje_organizacije': 'Da li ste sigurni da želite izbrisati organizacijsku jedinicu',
    'potvrda_brisanja_organizacije': 'Potvrda brisanja organizacijske jedinice',
    'uspjesno_obrisana_organizacija': 'Organizacijska jedinica je uspješno obrisana',
    'komentarisi_raspravu': 'KOMENTARIŠI RASPRAVU',
    'komentarisi_sjednicu': 'KOMENTARIŠI SJEDNICU',
    'Datum_diskusije_mora_biti_izmedju_datuma_pocetka_i_datuma_kraja_javne_rasprave': 'Datum diskusije mora biti između datuma početka i datuma kraja javne rasprave',
    'Datum_sesije_mora_biti_izmedju_datuma_pocetka_i_datuma_kraja_javne_rasprave': 'Datum sesije mora biti između datuma početka i datuma kraja javne rasprave',
    'Tip_debate': 'Tip javne rasprave',
    'Datum_od': 'Datum od',
    'Datum_do': 'Datum do',
    'Online': 'Online',
    'Offline': 'Offline',
    'Ispod_18': 'Ispod 18',
    'Preko_55': 'Preko 55',
    'Starosna_grupa': 'Starosna grupa',
    'Datum_prituzbe_od': 'Datum pritužbe od',
    'Datum_prituzbe_do': 'Datum pritužbe do',
    'preko_72h': 'Preko 72h',
    'kontakti_za_pomoc': 'Kontakti za pomoć',
    'politika_privatnosti': 'Politika privatnosti',
    'uslovi_zahtjevi': 'Uslovi i zahtjevi',
    'redni_broj': 'Redni broj',
    'redni_podbroj': 'Redni podbroj',
    'unesite_redni_broj': 'Unesite redni broj',
    'item_number_already_exists': 'Uneseni redni broj već postoji',
    'item_subnumber_already_exists': 'Uneseni redni pobroj već postoji',
    'naziv_tacke_dnevnog_reda_max_duzina': 'Naziv ne može biti duži od 2000 karaktera',
    'opis_tacke_dnevnog_reda_max_duzina': 'Opis ne može biti duži od 2000 karaktera',
    'DodajPodtocku': 'Dodaj podtočku',
    'status_obavezan': 'Odaberite status',
    'objavljen': 'Objavljen',
    'Za': 'Za',
    'Protiv': 'Protiv',
    'Suzdrzani': 'Suzdržani',
    'Odsutni': 'Odsutni',
    'saziv_je_obavezan': 'Saziv je obavezan',
    'pojedinacna_sjednica': 'Pojedinačna sjednica',
    'Tip_statistike': 'Tip statistike',
    'Datum_sjednice_od': 'Datum sjednice od',
    'Datum_sjednice_do': 'Datum sjednice do',
    'broj_tacaka_dnevnog_reda': 'Broj tačaka dnevnog reda',
    'broj_dokumenata': 'Broj dokumenata',
    'Svi': 'Svi',
    'tacke_dnevnog_reda_dokumenti_sjednica': 'Broj tačaka dnevnog reda i dokumenata po sjednicama',
    'datum_trajanje_sjednica': 'Održane sjednice u datumskom intervalu sa dužinom trajanja sjednica',
    'trajanje_sjednice': 'Trajanje sjednice',
    'Datum_zavrsetka_od': 'Datum završetka od',
    'Datum_zavrsetka_do': 'Datum završetka do',
    'Datum_vrijeme_zavrsetka': 'Datum i vrijeme završetka',
    'Datum_vrijeme_pocetka': 'Datum i vrijeme početka',
    'sjednice_podaci': 'Podaci o sjednicama',
    'Ucestvujte_u_diskusiji': 'Učestvujte u diskusiji',
    'Dodaj_komentar': 'Dodaj komentar',
    'sesije_sa_brojem_ucesnika': 'Sesije po javnim raspravama sa brojem učesnika',
    'javna_rasprava': 'Javna rasprava',
    'Datum_zavrsetka': 'Datum završetka',
    'Datum_sesije': 'Datum sesije',
    'broj_ucesnika_po_tipu_sesije': 'Broj učesnika po tipu sesije',
    'javne_rasprave_po_kategorijama': 'Javne rasprave po kategorijama',
    'broj_ucesnika_sesija_po_lokaciji': 'Broj učesnika i sesija po lokaciji',
    'tip_sesije': 'Tip sesije',
    'tip_javne_rasprave': 'Tip javne rasprave',
    'kategorija_javne_rasprave': 'Kategorija javne rasprave',
    'broj_sesija': 'Broj sesija',
    'br': 'Br.',
    'GradjanaZa': 'Građana za',
    'GradjanaProtiv': 'Građana protiv',
    'neprimjeren': 'Neprimjeren',
    'broj_odgovorenih': 'Broj odgovorenih',
    'broj_neodgovorenih': 'Broj neodgovorenih',
    'broj_odgovorenih_neodgovorenih_pitanja': 'Broj odgovorenih i neodgovorenih pitanja',
    'sva_pitanja': 'Sva pitanja',
    'offline_javne_rasprave_sa_ukupnim_brojem_ucesnika': 'Offline javne rasprave sa ukupnim brojem učesnika',
    'slanje_notifikacije_sms': 'Slanje notifikacije - SMS',
    'slanje_notifikacije_email': 'Slanje notifikacije - Email',
    'slanje_notifikacije_push': 'Slanje notifikacije - Push',
    'Broj_javnih_rasprava': 'Broj javnih rasprava',
    'politika_privatnosti_tekst': 'Prilikom registracije u svrhu korištenja online servisa prikupljaju se podaci o korisnicima. Podaci prikupljeni ovim putem (e-mail adrese, brojevi telefona) isključivo će biti korišteni za kontaktiranje s korisnicima i ni pod kojim uslovima neće biti dati na korištenje trećoj strani. Odgovornost za tačnost informacija o ličnim podacima snose korisnici stranice. \n\n Demografski podaci o korisnicima biti će korišteni za potrebe izvještavanja i analiza aktivnosti korisnika. Svi podaci će biti korišteni anonimno i neće ih biti moguće povezati sa email adresama ili brojevima telefona.',
    'uslovi_zahtjevi_podnaslov1': 'Prihvatanje uslova korištenja',
    'uslovi_zahtjevi_tekst1': 'Molimo Vas da pažljivo pročitate uslove korištenja prije samog korištenja ove web - stranice. Pristupanjem web-stranici i ostalim online servisima i korištenjem materijala s web-stranice i ostalih online servisa, obavezujete se prihvatiti navedena pravila korištenja. Ukoliko se ne slažete s ovim pravilima korištenja, molimo Vas da ne koristite informacije sa ove web-stranice.',
    'uslovi_zahtjevi_podnaslov2': 'Odricanje od odgovornosti',
    'uslovi_zahtjevi_tekst2': 'Vlasnik Web stranice sa online servisima za Građane ne snosi odgovornost za izravnu ili neizravnu štetu koja može nastupiti kao posljedica korištenja ili nemogućnosti korištenja dokumenata, informacija, materijala ili sadržaja s web-stranice, ili za posljedice odluka donesenih na temelju njih. Dozvoljeno je navođenje poveznice na ovu web - stranicu, pod uslovom da sadržaji s web - stranice nisu izmijenjeni i/ili iskrivljeni.',
    'uslovi_zahtjevi_podnaslov3': 'Izmjena i dopuna sadržaja',
    'uslovi_zahtjevi_tekst3': 'Vlasnik zadržava pravo izmjena i dopuna sadržaja na web-stranici bez prethodne najave. Web - stranica se redovno ažurira.',
    'uslovi_zahtjevi_podnaslov4': 'Autorska prava',
    'uslovi_zahtjevi_tekst4': 'Vlasnik zadržava autorsko pravo na ovu web-stranicu i na kompletan sadržaj, osim ako nije izričito naznačeno drugačije. Dopušteno je korištenje i citiranje materijala sa stranice, uz uslov obveznog navođenja izvora informacija i navođenja poveznice na ovu stranicu. Sadržaj informacija preuzetih s web - stranice ne smije biti mijenjan ili brisan. Materijal s ove web-stranice zabranjeno je koristiti u komercijalne svrhe.',
    'kontakti_za_pomoc_tekst': 'Kontaktirajte nas ukoliko Vam je potrebna pomoć prilikom korištenja eCitizen sistema\n\nEmail adresa:  ',
    'kontakti_za_pomoc_email': 'ecitizen_support@king-ict.ba',
    'Izvjestaj': 'Izvještaj',
    'Generisi_dokument': 'Generiši dokument',
    'Grupisanje_po': 'Grupisanje po',
    'Godina/Mjesec (Datum pritužbe)': 'Godina/Mjesec (Datum pritužbe)',
    'broj_javnih_rasprava_po_vrsti': 'Broj javnih rasprava po vrsti',
    'vrsta_javne_rasprave': 'Vrsta javne rasprave',
    'status_javne_rasprave': 'Status javne rasprave',
    'broj_javnih_rasprava_po_mjesecima_tipu': 'Broj javnih rasprava po mjesecima i tipu',
    'komentari_po_profilnim_podacima': 'Komentari po profilnim podacima',
    'Godina': 'Godina',
    'Mjesec': 'Mjesec',
    'Datum_pocetka_javne_rasprave': 'Datum početka javne rasprave',
    'disclaimer': 'Web Portal eCitizen razvijen je u okviru Projekta općinskog okolišnog upravljanja (MEG2) kojeg zajednički  finansiraju Vlada Švicarske, Švedska i Vlada Češke Republike, kao i Evropska unija, a provodi ga Razvojni program Ujedinjenih nacija (UNDP) u BiH. Sadržaj ovog portala, kao i stavovi prikazani na portalu, ne odražavaju nužno stavove Vlade Švicarske, Švedske, Vlade Češke Republike, Evropske unije, niti UNDP-a.',
    'Clan_kolegijuma': 'Član kolegija',
    'Pravo_odgovora': 'Pravo odgovora',
    'Pravo_odgovora_detalji': 'Korisnik koji ima "pravo odgovora" može da odgovara na pitanja koja su postavljena od strane građana. Ako org. jed. nema niti jednoga korisnika sa pravom odgovora, na tu org. jed. nije moguće postaviti pitanje.',
    'Clan_radnog_tijela': 'Član radnog tijela',
    'Kolegijum': 'Kolegij',
    'Radna_tijela': 'Radna tijela',
    'Saziv_Partija': 'Saziv + Partija',
    'Kategorija_Status': 'Kategorija + Status',
    'Kategorija_Profil': 'Kategorija + Profil',
    'Kategorija_Pol': 'Kategorija + Pol',
    'Godina/Mjesec rasprave': 'Godina/Mjesec rasprave',
    'Komentar_nije_unesen': 'Komentar nije unesen',
    'pitanje_brisanje_tacke_dnevnog_reda': 'Da li ste sigurni da želite izbrisati tačku dnevnog reda',
    'potvrda_brisanja_tacke_dnevnog_reda': 'Potvrda brisanja tačke dnevnog reda',
    'uspjesno_obrisana_tacka_dnevnog_reda': 'Tačka dnevnog reda je uspješno obrisana',
    'Kljucna_rijec_obavezna': 'Unesite ključnu riječ za pretragu javne rasprave',
    'Pristup_svim_sadrzajima': 'Prisup svim sadržajima',
    'Kreiranje_sadrzaja': 'Kreiranje/objava sadržaja',
    'Trajno_korisnicko_ime': 'Trajno korisničko ime',
    'Obavijesti_o_odgovorima': 'Obavijesti o odgovorima',
    'Sistemske_notifikacije': 'Sistemske notifikacije',
    'Push_notifikacije': 'Push notifikacije',
    'Prijavite_se': 'Prijava',
    'max_velicina_slike': 'Maksimalna veličina slike je',

    'grad_rs_clanovi_gradskog_vijeca': 'Profili / pitanja odbornika - gradonačelnika',
    'grad_rs_lista_clanova_gradskog_vijeca': 'Lista profila odbornika i gradonačelnika',
    'grad_rs_unos_novog_clana_gradskog_vijeca': 'Unos novog profila odbornika/gradonačelnika',
    'grad_rs_izmjena_clana_gradskog_vijeca': 'Izmjena profila odbornika/gradonačelnika',
    'grad_rs_pitanje_clanu_gradskog_vijeca': 'Pitanje odborniku/gradonačelniku',
    'grad_rs_clanovi_gradskog_opstinskog_vijeca': 'Odbornici/gradonačelnik',
    'grad_rs_pitanja_clanu_gradskog_opstinskog_vijeca': 'Pitanja postavljena odbornicima/gradonačelniku',
    'grad_rs_pitanja_odgovori_vijecnika': 'Pitanja/Odgovori po odbornicima/gradonačelniku',
    'grad_rs_vrijeme_odgovora_vijecnika': 'Vrijeme odgovora i prosječno vrijeme po odbornicima/gradonačelniku',
    'grad_rs_broj_pitanja_odgovora_po_clanu': 'Broj pitanja/odgovora po odborniku',
    'grad_rs_broj_pitanja_odgovora_gradonacelnik': 'Broj pitanja/odgovora po gradonačelniku',
    'grad_rs_broj_pitanja_odgovora_org': 'Broj pitanja/odgovora po organizacionoj jedinici',
    'grad_rs_vrijeme_odgovora_po_clanu': 'Vrijeme odziva/odgovora po odborniku (u časovima)',
    'grad_rs_vrijeme_odgovora_gradonacelnik': 'Vrijeme odziva/odgovora po gradonačelniku (u satima)',
    'grad_rs_vrijeme_odgovora_org': 'Vrijeme odziva/odgovora po organizacionoj jedinici (u satima)',
    'grad_rs_pitanje_brisanje_clana': 'Da li ste sigurni da želite izbrisati odbornika/gradonačelnika',
    'grad_rs_potvrda_brisanja_clana': 'Potvrda brisanja odbornika/gradonačelnika',
    'grad_rs_uspjesno_obrisan_clan': ' Odbornik/gradonačelnik je uspješno obrisan',
    'grad_rs_broj_prisutnih_vijecnika': 'Broj prisutnih odbornika',
    'grad_rs_broj_odsutnih_vijecnika': 'Broj odsutnih odbornika',
    'grad_rs_prosjecno_vrijeme_odgovora_po_vijecnicima': 'Prosječno vrijeme odgovora po odbornicima',
    'grad_rs_prosjecno_vrijeme_odgovora_gradonacelnik': 'Prosječno vrijeme odgovora po gradonačelniku',
    'grad_rs_prosjecno_vrijeme_odgovora_org': 'Prosječno vrijeme odgovora po organizacionoj jedinici',
    'grad_rs_odaberite_clana_vijeca': 'Odaberite odbornika/gradonačelnika',
    'grad_rs_pitanja_za_nacelnika': 'Pitanja postavljena gradonačelniku',
    'grad_rs_gradonacelnik': 'Gradonačelnik',
    'grad_rs_odbornici': 'Odbornici',

    'opstina_rs_pitanja_za_nacelnika': 'Pitanja postavljena načelniku',
    'opstina_rs_clanovi_gradskog_vijeca': 'Profili odbornika i načelnika',
    'opstina_rs_lista_clanova_gradskog_vijeca': 'Lista profila odbornika i načelnika',
    'opstina_rs_unos_novog_clana_gradskog_vijeca': 'Unos novog profila odbornika/načelnika',
    'opstina_rs_izmjena_clana_gradskog_vijeca': 'Izmjena profila odbornika/načelnika',
    'opstina_rs_pitanje_clanu_gradskog_vijeca': 'Pitanje odborniku/načelniku',
    'opstina_rs_clanovi_gradskog_opstinskog_vijeca': 'Odbornici',
    'opstina_rs_pitanja_clanu_gradskog_opstinskog_vijeca': 'Pitanja postavljena odbornicima',
    'opstina_rs_pitanja_odgovori_vijecnika': 'Pitanja/Odgovori po odbornicima/načelniku',
    'opstina_rs_vrijeme_odgovora_vijecnika': 'Vrijeme odgovora i prosječno vrijeme po odbornicima/načelniku',
    'opstina_rs_broj_pitanja_odgovora_po_clanu': 'Broj pitanja/odgovora po odborniku',
    'opstina_rs_broj_pitanja_odgovora_gradonacelnik': 'Broj pitanja/odgovora po načelniku',
    'opstina_rs_broj_pitanja_odgovora_org': 'Broj pitanja/odgovora po organizacionoj jedinici',
    'opstina_rs_vrijeme_odgovora_po_clanu': 'Vrijeme odziva/odgovora po odborniku (u časovima)',
    'opstina_rs_vrijeme_odgovora_gradonacelnik': 'Vrijeme odziva/odgovora po načelniku (u satima)',
    'opstina_rs_vrijeme_odgovora_org': 'Vrijeme odziva/odgovora po organizacionoj jedinici (u satima)',
    'opstina_rs_pitanje_brisanje_clana': 'Da li ste sigurni da želite izbrisati odbornika/načelnika',
    'opstina_rs_potvrda_brisanja_clana': 'Potvrda brisanja odbornika/načelnika',
    'opstina_rs_uspjesno_obrisan_clan': ' Odbornik/načelnik je uspješno obrisan',
    'opstina_rs_broj_prisutnih_vijecnika': 'Broj prisutnih odbornika',
    'opstina_rs_broj_odsutnih_vijecnika': 'Broj odsutnih odbornika',
    'opstina_rs_prosjecno_vrijeme_odgovora_po_vijecnicima': 'Prosječno vrijeme odgovora po odbornicima',
    'opstina_rs_prosjecno_vrijeme_odgovora_gradonacelnik': 'Prosječno vrijeme odgovora po načelniku',
    'opstina_rs_prosjecno_vrijeme_odgovora_org': 'Prosječno vrijeme odgovora po organizacionoj jedinici',
    'opstina_rs_odaberite_clana_vijeca': 'Odaberite odbornika/načelnika',
    'opstina_rs_gradonacelnik': 'Načelnik',
    'opstina_rs_odbornici': 'Odbornici',

    'grad_fbih_pitanja_za_nacelnika': 'Pitanja postavljena gradonačelniku',
    'grad_fbih_clanovi_gradskog_vijeca': 'Profili vijećnika i gradonačelnika',
    'grad_fbih_lista_clanova_gradskog_vijeca': 'Lista profila vijećnika i gradonačelnika',
    'grad_fbih_unos_novog_clana_gradskog_vijeca': 'Unos novog profila vijećnika/gradonačelnika',
    'grad_fbih_izmjena_clana_gradskog_vijeca': 'Izmjena profila vijećnika/gradonačelnika',
    'grad_fbih_pitanje_clanu_gradskog_vijeca': 'Pitanje vijećniku/gradonačelniku',
    'grad_fbih_clanovi_gradskog_opstinskog_vijeca': 'Vijećnici/gradonačelnik',
    'grad_fbih_pitanja_clanu_gradskog_opstinskog_vijeca': 'Pitanja postavljena vijećnicima/gradonačelniku',
    'grad_fbih_pitanja_odgovori_vijecnika': 'Pitanja/odgovori po vijećnicima/gradonačelniku',
    'grad_fbih_vrijeme_odgovora_vijecnika': 'Vrijeme odgovora i prosječno vrijeme po vijećnicima/gradonačelniku',
    'grad_fbih_broj_pitanja_odgovora_po_clanu': 'Broj pitanja/odgovora po vijećiku',
    'grad_fbih_broj_pitanja_odgovora_gradonacelnik': 'Broj pitanja/odgovora po načelniku',
    'grad_fbih_broj_pitanja_odgovora_org': 'Broj pitanja/odgovora po organizacijskoj jedinici',
    'grad_fbih_vrijeme_odgovora_po_clanu': 'Vrijeme odziva/odgovora po vijećniku (u satima)',
    'grad_fbih_vrijeme_odgovora_gradonacelnik': 'Vrijeme odziva/odgovora po gradonačelniku (u satima)',
    'grad_fbih_vrijeme_odgovora_org': 'Vrijeme odziva/odgovora po organizacijskoj jedinici (u satima)',
    'grad_fbih_pitanje_brisanje_clana': 'Da li ste sigurni da želite izbrisati vijećnika/gradonačelnika',
    'grad_fbih_potvrda_brisanja_clana': 'Potvrda brisanja vijećnika/gradonačelnika',
    'grad_fbih_uspjesno_obrisan_clan': 'Vijećnik/gradonačelnik je uspješno obrisan',
    'grad_fbih_broj_prisutnih_vijecnika': 'Broj prisutnih vijećnika',
    'grad_fbih_broj_odsutnih_vijecnika': 'Broj odsutnih vijećnika',
    'grad_fbih_prosjecno_vrijeme_odgovora_po_vijecnicima': 'Prosječno vrijeme odgovora po vijećnicima',
    'grad_fbih_prosjecno_vrijeme_odgovora_gradonacelnik': 'Prosječno vrijeme odgovora po gradonačelniku',
    'grad_fbih_prosjecno_vrijeme_odgovora_org': 'Prosječno vrijeme odgovora po organizacijskoj jedinici',
    'grad_fbih_odaberite_clana_vijeca': 'Odaberite vijećnika/gradonačelnika',
    'grad_fbih_gradonacelnik': 'Gradonačelnik',
    'grad_fbih_odbornici': 'Vijećnici',

    'opstina_fbih_pitanja_za_nacelnika': 'Pitanja postavljena načelniku',
    'opstina_fbih_clanovi_gradskog_vijeca': 'Profili vijećnika i načelnika',
    'opstina_fbih_lista_clanova_gradskog_vijeca': 'Lista profila vijećnika i načelnika',
    'opstina_fbih_unos_novog_clana_gradskog_vijeca': 'Unos novog profila vijećnika/načelnika',
    'opstina_fbih_izmjena_clana_gradskog_vijeca': 'Izmjena profila vijećnika/načelnika',
    'opstina_fbih_pitanje_clanu_gradskog_vijeca': 'Pitanje vijećniku/načelniku',
    'opstina_fbih_clanovi_gradskog_opstinskog_vijeca': 'Vijećnici/načelnik',
    'opstina_fbih_pitanja_clanu_gradskog_opstinskog_vijeca': 'Pitanja postavljena vijećnicima/načelniku',
    'opstina_fbih_pitanja_odgovori_vijecnika': 'Pitanja/odgovori po vijećnicima/načelniku',
    'opstina_fbih_vrijeme_odgovora_vijecnika': 'Vrijeme odgovora i prosječno vrijeme po vijećnicima/načelniku',
    'opstina_fbih_broj_pitanja_odgovora_po_clanu': 'Broj pitanja/odgovora po vijećniku',
    'opstina_fbih_broj_pitanja_odgovora_gradonacelnik': 'Broj pitanja/odgovora po načelniku',
    'opstina_fbih_broj_pitanja_odgovora_org': 'Broj pitanja/odgovora po organizacijskoj jedinici',
    'opstina_fbih_vrijeme_odgovora_po_clanu': 'Vrijeme odziva/odgovora po vijećniku (u satima)',
    'opstina_fbih_vrijeme_odgovora_gradonacelnik': 'Vrijeme odziva/odgovora po gradonačelniku (u satima)',
    'opstina_fbih_vrijeme_odgovora_org': 'Vrijeme odziva/odgovora po organizacijskoj jedinici (u satima)',
    'opstina_fbih_pitanje_brisanje_clana': 'Da li ste sigurni da želite izbrisati vijećnika/načelnika',
    'opstina_fbih_potvrda_brisanja_clana': 'Potvrda brisanja vijećnika/načelnika',
    'opstina_fbih_uspjesno_obrisan_clan': 'Vijećnik/načelnik je uspješno obrisan',
    'opstina_fbih_broj_prisutnih_vijecnika': 'Broj prisutnih vijećnika',
    'opstina_fbih_broj_odsutnih_vijecnika': 'Broj odsutnih vijećnika',
    'opstina_fbih_prosjecno_vrijeme_odgovora_po_vijecnicima': 'Prosječno vrijeme odgovora po vijećnicima',
    'opstina_fbih_prosjecno_vrijeme_odgovora_gradonacelnik': 'Prosječno vrijeme odgovora po gradonačelniku',
    'opstina_fbih_prosjecno_vrijeme_odgovora_org': 'Prosječno vrijeme odgovora po organizacijskoj jedinici',
    'opstina_fbih_odaberite_clana_vijeca': 'Odaberite vijećnika/načelnika',
    'opstina_fbih_gradonacelnik': 'Načelnik',
    'opstina_fbih_odbornici': 'Vijećnici',

    'ankete': 'Ankete',
    'lista_anketa': 'Lista anketa',
    'kod_ankete': 'Kod',
    'naslov_ankete': 'Naslov',
    'datum_kreiranja_ankete': 'Datum kreiranja',
    'datum_zavrsetka_ankete': 'Datum završetka ankete',
    'tip_ankete': 'Tip',
    'kategorija_ankete': 'Kategorija',
    'vrsta_ucesnika_ankete': 'Vrsta učesnika',
    'status_ankete': 'Status',
    'anketa_vazi_od': 'Važi od',
    'anketa_vazi_do': 'Važi do',
    'kod_ankete_obavezan': 'Kod ankete je obavezan',
    'naslov_ankete_obavezan': 'Naslov ankete je obavezan',
    'tip_ankete_obavezan': 'Tip ankete je obavezan',
    'kategorija_ankete_obavezna': 'Kategorija ankete je obavezna',
    'tip_ucesnika_ankete_obavezan': 'Vrsta učesnika ankete je obavezna',
    'status_ankete_obavezan': 'Status ankete je obavezan',
    'status_ankete_azuriran': 'Status ankete je ažuriran',
    'pocetni_datum_vazenja_ankete_obavezan': 'Početni datum važenja ankete je obavezan',
    'krajnji_datum_vazenja_ankete_obavezan': 'Krajnji datum važenja ankete je obavezan',
    'unos_nove_ankete': 'Unos nove ankete',
    'izmjena_ankete': 'Izmjena ankete',
    'detalji_ankete': 'Detalji ankete',
    'tip_pitanja': 'Tip pitanja',
    'zakljucano': 'Zaključano',
    'unos_novog_pitanja': 'Unos novog pitanja',
    'ponudjeni_odgovori': 'Ponuđeni odgovori',
    'ponudjeni_odgovor': 'Ponuđeni odgovor',
    'ponudjene_opcije_odgovora': 'Ponuđene opcije odgovora',
    'tekst_opcije_odgovora': 'Tekst opcije odgovora',
    'unos_ponudjenog_odgovora': 'Unos ponuđenog odgovora',
    'izmjena_ponudjenog_odgovora': 'Izmjena ponuđenog odgovora',
    'unos_opcije_ponudjenog_odgovora': 'Unos opcije ponuđenog odgovora',
    'izmjena_opcije_ponudjenog_odgovora': 'Izmjena opcije ponuđenog odgovora',
    'ponudjena_opcija_odgovora': 'Ponuđena opcija odgovora',
    'ucesnici_ankete': 'Učesnici ankete',
    'izmijeni': 'Izmijeni',
    'izmjena_ucesnika_ankete': 'Izmjena učesnika ankete',
    'osnovni_podaci_ankete': 'Osnovni podaci ankete',
    'tip_pitanja_obavezan': 'Tip pitanja je obavezan',
    'upozorenje_dodajte_pitanja': 'Dodajte pitanja. Anketa neće moći biti objavljena ukoliko ne postoje pitanja.',
    'upozorenje_odaberite_ucesnike': 'Odaberite učesnike ankete. Anketa neće moći biti objavljena ukoliko nisu odabrani učesnici.',
    'upozorenje_dodajte_ponudjenje_odgovore': 'Dodajte ponuđene odgovore. Pitanje neće moći biti objavljeno ukoliko ne postoje ponuđeni odgovori.',
    'objavi_anketu': 'Objavi anketu',
    'objava_ankete': 'Objava ankete',
    'pregled_ankete': 'Pregled ankete',
    'krajnji_datum_mora_biti_veci_od_pocetnog': 'Krajnji datum važenja ankete mora biti veći od početnog',
    'rezultati_ankete': 'Rezultati ankete',
    'obrisi_anketu': 'Obriši anketu',
    'potvrda_brisanja_ankete': 'Brisanje ankete',
    'pitanje_brisanje_ankete': 'Da li ste sigurni da želite obrisati anketu',
    'anketa_uspjesno_obrisana': 'Anketa uspješno obrisana',
    'potvrda_brisanja_pitanja_ankete': 'Brisanje pitanja ankete',
    'pitanje_brisanje_pitanja_ankete': 'Da li ste sigurni da želite obrisati pitanje',
    'pitanje_ankete_uspjesno_obrisano': 'Pitanje uspješno obrisano',
    'potvrda_brisanja_ponudjenog_odgovora': 'Brisanje ponuđenog odgovora',
    'pitanje_brisanje_ponudjenog_odgovora': 'Da li ste sigurni da želite obrisati ponuđeni odgovor',
    'ponudjeni_odgovor_uspjesno_obrisan': 'Ponuđeni odgovor uspješno obrisan',
    'master_anketa': 'Master anketa',
    'sms_verifikacija_obavezna': 'SMS verifikacija korisnika obavezna',
    'ukljuceno_slanje_podsjetnika': 'Uključeno slanje podsjetnika',
    'osjetljiva_kategorija_obavezna': 'Odabir osjetljive kat. obavezan',
    'primatelji_sistemske_notifikacije': 'Primatelji sistemske notifikacije',
    'dodajte_ponudjene_odgovore': 'Molim Vas da dodate ponuđene odgovore na pitanje',
    'dodajte_ponudjene_odgovore_i_opcije': 'Molim Vas da dodate ponuđene odgovore na pitanje, kao i ponuđene opcije odgovora',
    'generisi_qr_kod': 'Generiši QR kod ankete',
    'generisi_link_ankete': 'Generiši link ankete',
    'link_ankete_naslov': 'Link ankete',
    'sacuvano': 'Spašeno',
    'anketa_objavljena': 'Anketa objavljena',
    'napomena_kreiranje_ankete': 'Klikom na dugme Spasi sistem će poslati obavještenje o kreiranju ankete službenicima koji su označeni kao primaoci obavještenja.',
    'napomena_objava_ankete_1': 'Klikom na dugme Objavi sistem će automatski dodati datume važenja i promijeniti status ankete u modulu Master ankete.',
    'napomena_objava_ankete_2': 'Sistem će poslati obavještenje o objavljivanju ankete učesnicima ankete, kao i službenicima koji su označeni kao primaoci obavještenja.',
    'objavi': 'Objavi',
    'napomena': 'NAPOMENA',
    'azuriraj_status': 'Ažuriraj status',
    'treba_azurirati_status': 'Status ankete u modulu Master ankete nije ažuriran',
    'sinhronizuj_anketu': 'Sinhronizuj anketu',
    'anketa_sinhronizovana': 'Anketa sinhronizovana',
    'kopiraj_link': 'Kopiraj link',
    'link_ankete_kopiran': 'Link ankete uspješno kopiran',
    'sve_ankete': 'Sve ankete',
    'ukupno_ispunjeno': 'Ukupno ispunjeno',
    'ukupno': 'Ukupno',
    'registar_upravnih_postupaka': 'Registar administrativnih procedura',
    'lista_zivotnih_tema': 'Lista životnih tema',
    'objavljeno': 'Objavljeno',
    'naziv_zivotne_teme': 'Naziv životne teme',
    'administrativne_procedure': 'Administrativne procedure',
    'pravni_lijekovi': 'Pravni lijekovi',
    'lista_pravnih_lijekova': 'Lista pravnih lijekova',
    'detalji_zivotne_teme': 'Detalji životne teme',
    'podteme': 'Podteme',
    'naziv_podteme': 'Naziv podteme',
    'detalji_zivotne_podteme': 'Detalji životne podteme',
    'naziv_zivotne_podteme': 'Naziv životne podteme',
    'zivotna_tema': 'Životna tema',
    'upravni_postupci': 'Administrativne procedure',
    'naziv_upravnog_postupka': 'Naziv administrativne procedure',
    'e_usluge_informacije': 'Informacije o uslugamo elektronske uprave. Usluge su podijeljene na one za koje mozete preuzeti elektronske obrasce i one za koje možete zahtjev za uslugu podnijeti elektronski ukoliko se prijavite na korisnički dio portala. Servisi su podijeljeni po životnim temama.',
    'e_usluge_link': 'Registar administrativnih procedura/eUsluga',
    'e_usluge_podkategorija_link': 'Podkategorije',
    'e_usluge_detalji_link': 'Detalji o usluzi',
    'e_usluge_za_gradane': 'eUsluge za građane',
    'unos_novog_upravnog_postupka': 'Nova administrativna procedura',

    'nadlezna_visa_org_jedinica': 'Nadležna viša organizaciona jedinica',
    'nadlezna_niza_org_jedinica': 'Nadležna niža organizaciona jedinica',
    'nadlezna_org_jedinica': 'Nadležna organizaciona jedinica',
    'kontakt_osobe': 'Kontakt osobe',
    'kontakt_osoba': 'Kontakt osoba',
    'ime_i_prezime': 'Ime i prezime',
    'pozicija': 'Pozicija',
    'kontakt_telefon': 'Kontakt telefon',
    'kontakt_email': 'Kontakt email',
    'pravni_osnov': 'Pravni osnov',
    'taksa_naknada': 'Taksa/Naknada',
    'naziv_takse': 'Naziv takse',
    'iznos': 'Iznos',
    'broj_racuna': 'Broj računa',
    'poziv_na_broj': 'Poziv na broj',
    'potrebna_dokumentacija': 'Potrebna dokumentacija',
    'trazeni_dokument': 'Traženi dokument',
    'institucija_koja_izdaje': 'Institucija koja izdaje',
    'forma_dostave': 'Forma dostave',
    'komentar': 'Komentar',
    'instrukcije_korak_po_korak': 'Instrukcije korak po korak',
    'tekst': 'Tekst',
    'korisni_linkovi': 'Korisni linkovi',
    'opis': 'Opis',
    'url': 'URL',
    'upravni_postupak_dostupan_u_elektronskoj_formi': 'Administrativna procedura dostupna u elektronskoj formi',
    'dokumenti': 'Dokumenti',
    'naziv': 'Naziv',
    'na_koga_se_odnosi_usluga': 'Na koga se odnosi usluga',
    'tip_usluge': 'Tip usluge',
    'status_usluge': 'Status usluge',
    'nivo_sofisticiranosti': 'Nivo sofisticiranosti',
    'kriterijum': 'Kriterijum',
    'izlazni_rezultat': 'Izlazni rezultat',
    'izlazni_rezultat_obavezan': 'Izlazni rezultat je obavezan',
    'pravni_lijek': 'Pravni lijek',
    'pravni_lijek_obavezan': 'Pravni lijek je obavezan',
    'rok_za_rjesavanje': 'Rok za rješavanje (dana)',
    'vrijeme_vazenja_odluke': 'Vrijeme važenja odluke',
    'nadleznost_izvornog_registra': 'Nadležnost izvornog registra',
    'kod_je_obavezan': 'Kod je obavezan',
    'naziv_upravnog_postupka_obavezan': 'Naziv administrativne procedure je obavezan',
    'opis_upravnog_postupka_obavezan': 'Opis administrativne procedure je obavezan',
    'nadlezna_visa_org_jedinica_obavezna': 'Nadležna viša organizaciona jedinica je obavezna',
    'nadlezna_niza_org_jedinica_obavezna': 'Nadležna niža organizaciona jedinica je obavezna',
    'nadlezna_org_jedinica_obavezna': 'Nadležna organizaciona jedinica je obavezna',
    'pravni_osnov_obavezan': 'Pravni osnov je obavezan',
    'na_koga_se_odnosi_usluga_obavezno': 'Na koga se odnosi usluga je obavezno',
    'tip_usluge_obavezan': 'Tip usluge je obavezan',
    'status_usluge_obavezan': 'Status usluge je obavezan',
    'nivo_sofisticiranosti_obavezan': 'Nivo sofisticiranosti je obavezan',
    'kriterijum_obavezan': 'Kriterijum je obavezan',
    'rok_za_rjesavaje_obavezan': 'Rok za rješavanje je obavezan',
    'vrijeme_vazenja_odluke_obavezno': 'Vrijeme važenja odluke je obavezno',
    'ime_i_prezime_obavezno': 'Ime i prezime je obavezno',
    'pozicija_obavezna': 'Pozicija je obavezna',
    'iznos_obavezan': 'Iznos je obavezan',
    'broj_racuna_obavezan': 'Broj računa je obavezan',
    'poziv_na_broj_obavezan': 'Poziv na broj je obavezan',
    'trazeni_dokument_obavezan': 'Traženi dokument je obavezan',
    'institucija_obavezna': 'Institucija je obavezna',
    'forma_dostave_obavezno': 'Forma dostave je obavezna',
    'kontakt_osoba_obavezna': 'Kontakt osoba je obavezna',
    'instrukcije_obavezne': 'Instrukcije su obavezne',
    'nedozvoljeno_brisanje_kategorije_sa_potkategorijom': 'Odabrana kategorija u sebi sadrži potkategorije. Molimo izbrišite prvo potkategorije',
    'nedozvoljeno_brisanje_potkategorije_sa_procedurama': 'Odabrana kategorija u sebi sadrži administrativne procedure. Molimo izbrišite prvo procedure.',
    'odabir_clana_modal': 'Odabir člana vijeća/načelnika/gradonačelnika',
    'rekreiraj_anketu': 'Kopiraj anketu',
    'bazna_anketa': 'Bazna anketa',
    'rekreiranje_ankete': 'Kopiranje ankete',
    'anketa_uspjesno_kopirana': 'Anketa uspješno kopirana',
    'trajno_brisanje_profila_checkbox': 'Trajno brisanje profila',
    'trajno_brisanje_profila_napomena': 'Označavanje "Trajno brisanje profila" Vaš korisnički profil i podaci o profilu će biti trajno izbrisni iz sustava eCitizen-a.',
    'anketa_spremljena' : 'Anketa je spremljena',
    'izmijena_statusa_rijesena' : 'Nije moguće ažuritati status riješene pritužbe',
    'naziv_kategorije' : 'Naziv kategorije',
    'naziv_podkategorije' : 'Naziv podkategorije',
    'detalji_kategorije' : 'Detalji kategorije',
    'detalji_podkategorije' : 'Detalji podkategorije',
    'nedozvoljen_format_slike' : 'Nedozvoljen format slike. Dozvoljeni formati: jpg, jpeg, png, bmp, webp',
    'saziv_ne_postoji_ili_neaktivan': 'Saziv nije trenutni ili je neaktivan',
    'vijecnik_postoji': 'Odabrani korisnik već postoji kao vijećnik/gradonačenik',
}